import { motion } from "framer-motion";
import jorgePhoto from "@/assets/jorge-regis.webp";

const FounderSection = () => (
  <section id="fundador" className="py-16 md:py-24">
    <div className="container">
      <div className="grid items-center gap-10 md:grid-cols-2">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          className="relative mx-auto w-full max-w-sm"
          title="Jorge Regis — Consultor empresarial com atuação em todo o Brasil"
        >
          <div className="absolute -inset-3 rounded-2xl bg-gradient-orange opacity-20 blur-2xl" />
          <img
            src={jorgePhoto}
            alt="Jorge Regis — Fundador do Negócio Conectado"
            width={800}
            height={1018}
            className="relative rounded-2xl object-cover shadow-lg"
            loading="lazy"
            decoding="async"
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
        >
          <span className="mb-3 inline-block rounded-full bg-accent px-4 py-1.5 text-sm font-semibold text-accent-foreground">
            Quem Está Por Trás
          </span>
          <h2 className="mb-4 text-2xl font-extrabold text-foreground sm:text-3xl">
            Jorge Regis
          </h2>
          <p className="mb-4 text-base leading-relaxed text-muted-foreground">
            Fundador da <strong className="text-foreground">Infotec Sistemas</strong> — empresa
            com clientes em <strong className="text-foreground">20 estados do Brasil</strong> e{" "}
            <strong className="text-foreground">11 países</strong>.
          </p>
          <p className="mb-4 text-base leading-relaxed text-muted-foreground">
            Mentor do <strong className="text-foreground">Negócio Conectado</strong> e{" "}
            <strong className="text-foreground">Diretor de Revendas da AFRAC Brasil</strong>,
            com 22 anos de experiência em vendas e crescimento de negócios.
          </p>
          <p className="text-base leading-relaxed text-muted-foreground">
            "Nosso maior case de sucesso somos nós mesmos. Tudo que ensinamos, fizemos primeiro."
          </p>
        </motion.div>
      </div>
    </div>
  </section>
);

export default FounderSection;
